<span fxLayout="row" fxFlex="100" fxLayoutAlign="center start">
  <span fxLayout="column" class="position-relative lane-body" fxFlex="0 1 900px" fxFlex.xs="100" fxFlex.sm="100">
    <span *ngIf="!loading && swimlane.items && swimlane.items.length > 0">
      <span fxLayout="column" class="res-pad-lr-0-20 carousel-fix-width w-100" fxLayoutGap="10px">
        <span *ngFor="let item of swimlane.items;" fxLayout="column" fxFlex="100" fxLayoutAlign="start"
          fxLayoutGap="10px">

          <span class="dekstop-row-mobile-column" 
              fxLayout="column" 
              fxLayout.gt-sm="row"               
              fxFlex="100">
            
            <span fxLayout="column" class="mobile-only" >
              <!-- Overline Titel (Mobile only)-->              
              <span>                
                <h2 class="mat-headline-2 mb5px">{{item.title}}</h2>
              </span>
              <span>                
                {{item.genre}}, 
                {{item.runtime ? item.runtime + ' Minuten, ' : ''}}                
                {{getAlterText(3) | translate}} Jahren
              </span>                            
            </span>

            <span fxFlex="20px" class="mobile-only"></span>

            <!-- Kachel -->
            <span class="mb-1 carousel-card">
              <span class="h-100 position-relative overflow-hidden" fxLayout="row">
                
                <img [src]="item.imagelow ? (item.imagelow | safe: 'resourceUrl') : PLACEHOLDER_IMAGE_WITH_PATH"
                  class="carousel-card-image desktop-only" style="z-index: 1;" [alt]="item.title + ' - ' + 'extra.image' | translate"
                  (load)="imageLoaded = true" [class.loaded]="imageLoaded" (error)="onImageError($event)"
                  fetchpriority="low" loading="lazy">

                <img [src]="item.imagehigh ? (item.imagehigh | safe: 'resourceUrl') : PLACEHOLDER_IMAGE_WITH_PATH"
                  class="carousel-card-image mobile-only" style="z-index: 1;" [alt]="item.title + ' - ' + 'extra.image' | translate"
                  (load)="imageLoaded = true" [class.loaded]="imageLoaded" (error)="onImageError($event)"
                  fetchpriority="low" loading="lazy">

                <span class="overlay-shade position-absolute overfill zero-pos">
                  <span fxLayout="column" fxLayoutAlign="end" class="h-100 padding-badges">
                    <span fxLayout="row" fxLayoutGap="6" fxLayoutAlign="end end"  *ngIf="item.itemclass !== sic.Redtext">                        
                        <img *ngIf="item.rating === 4" style="padding-bottom: 4px;" class="image-size-35x35 p4px" [alt]="'searchList.selectors.ratingOptions.4' | translate" src="assets/media/rating_badge.svg">
                        <img [alt]="'extra.socialmedia' | translate" *ngIf="item.itemclass === sic.Ytbesprechung" class="image-size-35x35" src="assets/media/ico_socialmedia.svg">
                        <app-age-category-badge class="image-size-35x35" *ngIf="item.altersfreigabe && item.rating > 2" [ageCategory]="item.altersfreigabe"></app-age-category-badge>
                        <app-traffic-lights class="image-size-18x46" [rating]="item.rating"></app-traffic-lights>                      
                    </span>
                  </span>
                </span>
              </span>
            </span>

            <span fxLayout="column">
              <!-- Overline Titel (Desktop only) -->
              <span class="desktop-only">                
              <span>
                <h2 class="mat-headline-2 mb5px">{{item.title}}</h2>
              </span>
              <span>                
                {{item.genre}}, 
                {{item.runtime ? item.runtime + ' Minuten, ' : ''}}                
                {{getAlterText(item.altersfreigabe) | translate}} Jahren
              </span>
              </span>
              <!-- Flimmo Meint -->
              <span class="mb1 title-content-gap">
                <span class="primary-color mat-headline-1 center-h1" style="padding-right: 10px;">FLIMMO meint</span>
                {{item.paed}}
              </span>

              <!-- Button -->
              <span fxFlex="20px" class="mobile-only"></span>
              <span style="margin-top: auto; "> 
                <button 
                  class="align-items-center justify-content-center flimmo-outline-button f-button-label text-decoration-none black"
                  (click)="open(generatelinks(item))">Mehr Infos</button>
              </span>
            </span>
          </span>

          <span fxFlex="40px"></span>
        </span>
      </span>
    </span>
  </span>
</span>